var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgNoDataLocation = function SvgNoDataLocation(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "80px",
    height: "80px",
    viewBox: "0 0 80 80",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "path-1",
    x: 0,
    y: 0,
    width: 40,
    height: 40
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "4.-Health-Screening",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "4.5.0-Setup-/-Location---empty-state",
    transform: "translate(-809.000000, -415.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "04.Organisms/07.Card/04.Confirmation/Empty-state",
    transform: "translate(697.000000, 415.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(112.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#F1F1F1",
    x: 0,
    y: 0,
    width: 80,
    height: 80,
    rx: 40
  }), /*#__PURE__*/React.createElement("g", {
    id: "Icon",
    transform: "translate(20.000000, 20.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Mask"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20,5.41666659 C25.7434896,5.41666659 30.4166667,9.88606766 30.4166667,15.3776041 C30.4166667,17.9941406 29.2246094,21.4720052 26.8776042,25.7148438 C24.9895834,29.1223959 22.8033854,32.2037761 21.6692708,33.7369792 C21.2799243,34.2683004 20.6606586,34.5822438 20.0019531,34.5822438 C19.3432477,34.5822438 18.7239819,34.2683004 18.3346354,33.7369792 C17.1985677,32.2037761 15.0143229,29.1223959 13.126302,25.7148438 C10.7753906,21.4707031 9.58333328,17.9928385 9.58333328,15.3776041 C9.58333328,9.88606766 14.2565104,5.41666659 20,5.41666659 Z M20,11.6666666 C17.6988135,11.6666666 15.8333333,13.5321468 15.8333333,15.8333333 C15.8333333,18.1345198 17.6988135,20 20,20 C22.3001453,19.9974883 24.164155,18.1334786 24.1666667,15.8333333 C24.1666667,13.5321468 22.3011865,11.6666666 20,11.6666666 Z M20,13.75 C21.1505932,13.75 22.0833333,14.6827401 22.0833333,15.8333333 C22.0833333,16.9839265 21.1505932,17.9166667 20,17.9166667 C18.8494068,17.9166667 17.9166667,16.9839265 17.9166667,15.8333333 C17.9166667,14.6827401 18.8494068,13.75 20,13.75 Z",
    id: "Combined-Shape",
    fill: "#999999",
    mask: "url(#mask-2)"
  }))))))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgNoDataLocation, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/no-data-location.d8ab0f07.svg";
export { ForwardRef as ReactComponent };